import React from 'react';
import styled, { keyframes, css } from 'styled-components';

// 定义淡入上移动画
const fadeUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

// 动画基础样式（通过 props 传入 delay）
const animatedStyle = css`
  opacity: 0;
  animation: ${fadeUp} 12s cubic-bezier(0.2, 0.9, 0.4, 1.1) forwards;
  animation-delay: ${props => props.delay || '0s'};
  will-change: transform, opacity;
`;

// Styled 组件
const Container = styled.div`
  display: flex;
  justify-content: center;
  // padding: 2rem 1.5rem;
  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
`;

const Article = styled.div`
  max-width: 780px;
  width: 100%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(2px);
  // border-radius: 2rem;

  // box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.1);


`;

const H1 = styled.h1`

  letter-spacing: -0.02em;
  background: linear-gradient(135deg, #1e2b3c, #2c4c6c);
  background-clip: text;
  -webkit-background-clip: text;
  // color: transparent;
  ${animatedStyle}
  line-height: 1.7;
  padding: 0;
  margin: 0;
  font-weight: 400;
  font-size: 1.7vh;
  @media (max-width: 640px) {
    // font-size: 1.9rem;
  }
`;

const Subtitle = styled.div`
  font-size: 1.1rem;
  color: #5b6e7c;
  border-left: 4px solid #8ba5b5;
  padding-left: 1rem;
  margin: 0.25rem 0 1rem 0;
  font-weight: 400;
  ${animatedStyle}

  @media (max-width: 640px) {
    font-size: 0.95rem;
  }
`;

const Author = styled.div`
  font-size: 0.85rem;
  color: #7f8c8d;
  margin: 0.5rem 0 1.8rem 0;
  letter-spacing: 0.3px;
  border-bottom: 1px dashed #dce5e8;
  padding-bottom: 0.75rem;
  ${animatedStyle}
`;

const H2 = styled.h2`
  font-size: 1.8rem;
  font-weight: 600;
  margin: 1.8rem 0 0.8rem 0;
  color: #1f3b4a;
  letter-spacing: -0.01em;
  ${animatedStyle}

  @media (max-width: 640px) {
    font-size: 1.5rem;
  }
`;

const Paragraph = styled.p`
  font-weight: 400;
  ${animatedStyle}
  line-height: 1.7;
  padding: 0;
  margin: 0;
  text-indent: 2em; 
  @media (max-width: 640px) {
    // font-size: 0.98rem;
  }
`;

const Signature = styled.div`
  text-align: right;
  line-height: 1.7;
  padding: 0;
  margin: 0;
  // font-style: italic;
  ${animatedStyle}
`;



// 尊重用户减少动画的偏好
const GlobalStyle = styled.div`
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

const App = () => {
  // 文章内容结构
  const content = [
    { type: 'h1', content: '亲爱的市值风云朋友：' },
    { type: 'p', content: '自2016年4月26日成立至今，市值风云已走过整整十载。十年深耕，一路同行，我们向前的每一步，都离不开您的信任、支持与陪伴。在此，向您致以最诚挚的感谢！' },
    // { type: 'author', content: '作者：渐现编辑部 | 发布于 2025年4月' },
    { type: 'p', content: '下一个十年，愿我们继续携手并进，共同迎接A股坚实有力的慢牛行情，愿大家投资成功、收益长虹，一路向阳，未来可期！' },
    // { type: 'p', content: '渐变效果（Fade-in）搭配轻微的位移，能够让内容“浮出”水面，减少突然出现的突兀感。心理学研究表明，平滑的视觉过渡能降低认知负荷，让读者更专注于文本本身。这正是我们设计“从上往下渐显”体验的初衷。' },
    // { type: 'h2', content: '✨ 设计原理：轻量而有效' },
    // { type: 'p', content: '我们为每个文本块设置了独立的动画：从透明度 0 到 1，同时伴随 8px 的上移（Y轴方向）。每个块按顺序延迟 0.15 秒至 0.2 秒依次播放，形成自上而下的“波浪式”显现。整个动画使用 CSS 硬件加速，性能流畅，且不会干扰用户滚动或交互。' },
    // { type: 'p', content: '这种渐进式展示特别适合长文章、产品介绍页、故事叙述或教程文档。它让首屏不再单调，也缓解了大段文字带来的压迫感。读者会不自觉地跟随动画节奏阅读，提升完读率。' },
    // { type: 'h2', content: '🎨 实现亮点' },
    // { type: 'p', content: '• 纯 CSS 动画，零 JavaScript 计时器，性能优异。\n• 每个文本块独立控制延迟，严格遵循从上到下的自然阅读顺序。\n• 响应式设计，适配手机、平板和桌面设备。\n• 支持 prefers-reduced-motion，尊重用户对动画的偏好设置。' },
    // { type: 'p', content: '此外，我们使用了柔和的中性背景与深灰色文字，保证长时间阅读的舒适性。文章的标题、小标题、正文和落款都有各自的视觉层级，但动画的一致性又让整体和谐统一。' },
    // { type: 'p', content: '试试滚动页面，你会发现每个新出现的区域依然延续了这份细腻的渐变质感。这就是“从上往下展示”的完整诠释：不仅仅是初次加载，更是每一寸内容与读者的温柔相遇。' },
    { type: 'signature', content: '市值风云创始人：杨峰 ' },
     { type: 'signature', content: '2026年4月' },
  ];

  // 根据类型渲染对应组件，并计算动画延迟
  const renderItem = (item, index) => {
    const delay = `${0.1 + index * 0.13}s`; // 依次增加延迟
    switch (item.type) {
      case 'h1':
        return <H1 key={index} delay={delay}>{item.content}</H1>;
      case 'h2':
        return <H2 key={index} delay={delay}>{item.content}</H2>;
      case 'subtitle':
        return <Subtitle key={index} delay={delay}>{item.content}</Subtitle>;
      case 'author':
        return <Author key={index} delay={delay}>{item.content}</Author>;
      case 'signature':
        return <Signature key={index} delay={delay}>{item.content}</Signature>;
      case 'p':
      default:
        // 处理换行符（如列表中的换行）
        const lines = item.content.split('\n');
        if (lines.length > 1) {
          return (
            <Paragraph key={index} delay={delay}>
              {lines.map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i !== lines.length - 1 && <br />}
                </React.Fragment>
              ))}
            </Paragraph>
          );
        }
        return <Paragraph key={index} delay={delay}>{item.content}</Paragraph>;
    }
  };

  return (
    <GlobalStyle>
      <Container>
        <Article>
          {content.map((item, idx) => renderItem(item, idx))}
          
        </Article>
      </Container>
    </GlobalStyle>
  );
};

export default App;


// WEBPACK FOOTER //
// ./src/views/activity_210/Card.js